import * as amplitude from '@amplitude/analytics-browser'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import * as React from 'react' // needed for bugsnag
import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga'
import { HashRouter } from 'react-router-dom'

import './index.css'
import './font.css'
import '@dialogueconsulting/sked-preview/dist/style.css'
import Homepage from './Homepage'
import { cleanGoogleTrackingParams } from './utils/cleanGoogleTrackingParams'
import { mswDomainWhitelist } from './utils/mswWhitelist'

// Clean Google tracking parameters before app initialization
cleanGoogleTrackingParams()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement!)

if (import.meta.env.MODE === 'test' || import.meta.env.MODE === 'mock') {
  console.log('Starting in test mode with mocks')
  const { worker } = await import('../mocks/browser')

  await worker.start({
    onUnhandledRequest(request, print) {
      //const url = new URL(request.url)

      // Ignore requests to fetch static assets.
      if (mswDomainWhitelist.some((domain) => request.url.includes(domain))) {
        return
      }

      // Otherwise, print a warning for any unhandled request.
      print.warning()
      // or bypass the url completely and send it to the app
      //return
    },
  })

  root.render(
    <HashRouter>
      <Homepage />
    </HashRouter>
  )
} else if (import.meta.env.MODE === 'production') {
  amplitude.init('b9fffa187362da24a877793990facd0e', {
    autocapture: true,
  })

  Bugsnag.start({
    apiKey: '6f94020a60e1c9623e2fb1ef4d743676',
    plugins: [new BugsnagPluginReact()],
    onError: function (event) {
      // Filter out non-Error objects that might be caught by the unhandled rejection handler
      if (event.originalError && !(event.originalError instanceof Error)) {
        // Convert to proper Error object
        const originalError = event.originalError
        event.errors[0].errorMessage =
          typeof originalError === 'string'
            ? originalError
            : JSON.stringify(originalError)
        // Add metadata about the non-Error object
        event.addMetadata('nonErrorObject', {
          type: typeof originalError,
          value: originalError,
        })
      }
      return true
    },
  })
  ReactGA.initialize('UA-46264715-12')
  ReactGA.pageview(
    window.location.pathname + window.location.search + window.location.hash
  )
  const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React)

  root.render(
    <ErrorBoundary>
      <HashRouter>
        <Homepage />
      </HashRouter>
    </ErrorBoundary>
  )
} else {
  // include amplitude in staging
  if (!window.location.hostname.includes('localhost')) {
    amplitude.init('b9fffa187362da24a877793990facd0e', {
      autocapture: true,
    })
  }

  root.render(
    <HashRouter>
      <Homepage />
    </HashRouter>
  )
}
